// FILE: stratify_website/src/pages/JustenChartrandPage.jsx
import React from "react";
import { SITE } from "../config/site";
import { Meta } from "../layout/EducationMeta";
import GlassCard from "../components/ui/GlassCard";

export default function JustenChartrandPage() {
  const canonical = `${SITE.url}/about/justen-chartrand`;

  const person = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Justen Chartrand",
    jobTitle: "Co-Founder & Product Lead",
    worksFor: { "@type": "Organization", name: SITE.name, url: SITE.url },
    url: canonical,
    image: `${SITE.url}/images/justenprofileimage.JPG`,
    description:
      "Co-founder at Stratify Backtesting focused on product, UI/UX, and building a mobile-first strategy wallet for backtesting, monitoring, and strategy notifications.",
    knowsAbout: [
      "Strategy monitoring",
      "Backtesting",
      "Trading rules",
      "Product design",
      "UI/UX",
      "Signal alerts",
      "Portfolio workflows",
      "Technical analysis",
    ],
    // ✅ add real profiles for maximum name SEO
    sameAs: [
      // "https://www.linkedin.com/in/your-link",
      // "https://github.com/your-handle"
    ],
  };

  return (
    <div className="mx-auto w-full max-w-[110rem] px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 py-10">
      <Meta
        title="Justen Chartrand — Co-Founder & Product Lead | Stratify Backtesting"
        description="Justen Chartrand is the co-founder and product lead at Stratify Backtesting, building a mobile-first strategy wallet for backtesting, monitoring, and signal notifications."
        canonical={canonical}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(person) }}
      />

      <div className="max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-ink">
          Justen Chartrand
        </h1>
        <p className="mt-2 text-muted">Co-Founder & Product Lead, Stratify Backtesting</p>
        <p className="mt-4 text-sm md:text-base text-muted leading-relaxed">
          I’m building Stratify to help traders stay consistent with rule-based strategies —{" "}
          <span className="text-ink">
            backtest fast, monitor conditions, and get notified when a setup changes
          </span>
          , without living on charts.
        </p>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-12">
        <GlassCard className="p-6 md:col-span-4">
          <img
            src="/images/justenprofileimage.JPG"
            alt="Justen Chartrand portrait"
            className="w-full h-auto rounded-2xl ring-1 ring-ink/10 object-cover"
            loading="lazy"
            decoding="async"
          />
        </GlassCard>

        <GlassCard className="p-6 md:col-span-8">
          <div className="text-sm font-semibold text-ink">Bio</div>
          <p className="mt-2 text-sm text-muted leading-relaxed">
            Justen is a co-founder of Stratify Backtesting
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <div className="rounded-xl border border-ink/8 bg-bg1 p-4">
              <div className="text-xs font-semibold text-ink">Focus</div>
              <div className="mt-1 text-xs text-muted leading-relaxed">

              </div>
            </div>

            <div className="rounded-xl border border-ink/8 bg-bg1 p-4">
              <div className="text-xs font-semibold text-ink">Building</div>
              <div className="mt-1 text-xs text-muted leading-relaxed">

              </div>
            </div>
          </div>

          <div className="mt-5 rounded-xl border border-ink/8 bg-white/[0.02] p-4">
            <div className="text-xs font-semibold text-ink">What I care about</div>
            <div className="mt-1 text-xs text-muted leading-relaxed">

            </div>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
